export default __webpack_public_path__ + "static/media/bluePinterest.eb7e7740.svg";